import {
  IRequirementDefinitionResponse,
  RequirementType
} from "@wingspanhq/payments/dist/interfaces";
import { useBackgroundChecksPackagesQuery } from "../../../../../query/backgroundChecks/queries/useBackgroundChecksPackagesQuery";
import { useConfirmCreateRequirementModal } from "../../../components/CreateRequirementDefinitionForm/useConfirmCreateRequirementModal";
import { CreateRequirementDefinitionFormValues } from "../../../../Requirements/types";
import { CreateRequirementDefinitionIdentityVerificationPartialForm } from "../../../../Requirements/modules/IdentityVerification/types";
import {
  convertFormApprovalDataToReviewStrategy,
  convertFormDataToExpirationStrategy
} from "../../../components/CreateRequirementDefinitionForm/utils";

type Params = {
  engagementId?: string;
  onSuccess: (requirement: IRequirementDefinitionResponse) => void;
};

export const useCreateIdentityVerificationRequirementDefinition = ({
  engagementId,
  onSuccess
}: Params) => {
  const queryBackgroundChecks = useBackgroundChecksPackagesQuery();

  const confirmCreateRequirementModal = useConfirmCreateRequirementModal();

  const onSubmit = async (
    formValues: CreateRequirementDefinitionFormValues &
      CreateRequirementDefinitionIdentityVerificationPartialForm
  ) => {
    // open confirmation modal to create requirement
    await confirmCreateRequirementModal.open({
      engagementId,
      // dataSourceType: DefinitionDataSourceType.BackgroundCheckRequestSettings,
      // dataSourceId: "",
      name: formValues.name,
      description: formValues.description,
      requirementType: RequirementType.IdentityVerification,
      reviewStrategy: convertFormApprovalDataToReviewStrategy(formValues),
      onSuccess(requirement) {
        onSuccess?.(requirement);
      },
      ...convertFormDataToExpirationStrategy(formValues)
    });
  };

  return {
    onSubmit,
    errors: undefined,
    isLoading: queryBackgroundChecks.isInitialLoading,
    isEnabled: true
  };
};
